import { render, staticRenderFns } from "./GoOrderPage.vue?vue&type=template&id=fb1c30c2&scoped=true&lang=pug&"
import script from "./GoOrderPage.vue?vue&type=script&lang=js&"
export * from "./GoOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./GoOrderPage.vue?vue&type=style&index=0&id=fb1c30c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1c30c2",
  null
  
)

export default component.exports